import { render, staticRenderFns } from "./PolicyCustomWorkbench.vue?vue&type=template&id=e1008ed8"
import script from "./PolicyCustomWorkbench.vue?vue&type=script&lang=js"
export * from "./PolicyCustomWorkbench.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports